import { Fragment, useEffect, useState, useRef } from "react";

import "../chapter.css";


const pageone = (props) => {
    return (
        <Fragment >
            <div className="pageformat height">
                <div className="text-center chapter-title">
                    <h1>Chapter 5</h1>
                </div>
                <div className="text-center chapter-content">
                    <p>It is a long esta    blished fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).</p>
                </div>
                <div className="page-number">
                    <span className="digite-number">1</span>
                </div>
            </div>
        </Fragment>
    )
}
export default connect(pageone);